<script>
  import { onMount } from "svelte";
  import { mapStore } from "../../stores/map.store";
  import { hooksStore } from "../../stores/hooks.store";
  import { userStore } from "../../stores/user.store";
  import { configStore } from "../../stores/config.store";
  import { tempStore } from "../../stores/temp.store";
  import {
    vratVrstvyMapyPodlaTypu,
    vratHtmlKodFarbyPodlaTypu,
    vratTypPodlaKodu,
  } from "../../helpers/config";
  import { datalayer, datalayersClear } from "../../helpers/datalayers";

  import { get as get_store } from "svelte/store";
  import get from "get-value";
  import SideManager from "./SideManager.svelte";
  import Popup from "./Popup.svelte";
  import Controls from "./Controls/Controls.svelte";

  let meranieAktivne = false;

  import {
    ulozAktualneZobrazenieMapy,
    ziskajUlozenuPoziciuMapy,
  } from "./maplibre.func";

  import { sourceExists } from "../../helpers/map";

  const port = location.port || (location.protocol === "https:" ? "443" : "80");

  let container, map;
  /**
   * kedze nacitanie maplibre chvilku trva a nacitava sa az po mountnuti tohto komponentu
   * tak si nacitanu mapu ukladam do store aby som ju mohol pouzit aj neskor (ked sa nacita mapbox)
   */
  mapStore.initMap({
    getMap: () => map,
  });

  hooksStore.addAction("resizeMaplibre", "Maplibre", () => {
    map.resize();
  });

  hooksStore.addAction("aktualizujVrstvyNaMape", "Maplibre", () => {
    let podkladova_interna = false;
    let vrstvy = get(get_store(userStore), "options.mapa.vrstvy", false);
    let vrstvyUrl = {
      internal: {
        vector: "",
        raster: "",
      },
      external: {
        vector: [],
        raster: [],
      },
    };

    datalayersClear(map, vrstvy);

    map
      .getStyle()
      .layers.filter((l) => l.source.startsWith("interne_vrstvy_"))
      .forEach((l) => map.removeLayer(l.id));

    for (const source_id in map.getStyle().sources) {
      if (source_id.startsWith("interne_vrstvy_")) {
        map.removeSource(source_id);
      }
    }

    let external_ids = [];
    vrstvy.forEach((vrstva) => {
      if (vrstva.isExternal === "1" ? true : false) {
        vrstvyUrl["external"][vrstva.typ].push({
          kod: vrstva.kod,
          url: vrstva.kodUrl,
          input_type: vrstva.input_type,
        });
        external_ids.push(`externe_vrstvy_${vrstva.kod}`);
      } else {
        vrstvyUrl["internal"][vrstva.typ] += vrstva.kodUrl;
        vrstvyUrl["internal"][vrstva.typ] +=
          vrstva.input_type === "radio" ? "|" : ",";
        podkladova_interna = vrstva.input_type === "radio";
      }
    });

    map
      .getStyle()
      .layers.filter(
        (l) =>
          l.source.startsWith("externe_vrstvy_") &&
          !external_ids.includes(l.source)
      )
      .forEach((l) => map.removeLayer(l.id));

    for (const source_id in map.getStyle().sources) {
      if (
        source_id.startsWith("externe_vrstvy_") &&
        !external_ids.includes(source_id)
      ) {
        map.removeSource(source_id);
      }
    }

    for (const type in vrstvyUrl) {
      if (type === "internal" && vrstvyUrl["internal"][type]) {
        vrstvyUrl["internal"][type] = vrstvyUrl["internal"][type].replace(
          /,\s*$/,
          ""
        );
      }
    }

    for (const type in vrstvyUrl["internal"]) {
      const id = `interne_vrstvy_${type}`;

      if (vrstvyUrl["internal"][type] === "") {
        continue;
      }

      const layers = map.getStyle() ? map.getStyle().layers : false;
      const firstLayerId = layers.length ? layers[0].id : null;
      if (type === "vector") {
        map.addSource(id, {
          type: type,
          tiles: [
            `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/tilemap/vector/{x}.{y}.{z}.${vrstvyUrl["internal"][type]}.pbf`,
          ],
          maxzoom: 15,
          minzoom: 0,
        });

        const typy = vrstvyUrl["internal"][type].split(",");
        typy.forEach((typ) => {
          const source_id = `${id}_${typ}`;
          const vrstvy = vratVrstvyMapyPodlaTypu(typ);
          const celyTyp = vratTypPodlaKodu(typ);
          if (vrstvy) {
            vrstvy.forEach((vrstva, i) => {
              // vrstva moze mat nastavenia pre paint aj pre layout. Je to podla rozneho typu vrstvy
              for (const v in vrstva.paint) {
                if (typeof vrstva.paint[v] === "string") {
                  vrstvy[i].paint[v] = vrstvy[i].paint[v].replace(
                    /\%kod_farby\%/,
                    `#${vratHtmlKodFarbyPodlaTypu(typ)}`
                  );
                }
              }

              for (const v in vrstva.layout) {
                if (typeof vrstva.layout[v] === "string") {
                  vrstvy[i].layout[v] = vrstvy[i].layout[v].replace(
                    /\%kod_farby\%/,
                    `#${vratHtmlKodFarbyPodlaTypu(typ)}`
                  );
                }
              }

              // ak nemam v konfigu vetvu pre layout, tak ju vytvorim
              if (vrstva.layout === undefined) {
                vrstva.layout = {};
              }

              const typ_vrstvy = vrstva.typ_vrstvy;
              // vytvorim layer pre danu vrstvu
              let layerOptions = {
                id: `${source_id}_${i}`,
                type: typ_vrstvy,
                source: id,
                minzoom: vrstva.minzoom || null,
                paint: vrstva.paint || {},
                layout: vrstva.layout || {},
              };
              if (vrstva.filter) {
                layerOptions.filter = vrstva.filter;
              }
              if (celyTyp.koddb) {
                layerOptions["source-layer"] = celyTyp.koddb;
              } else {
                layerOptions["source-layer"] = typ.replace(/^v/, "");
              }
              const l = map.addLayer(layerOptions, firstLayerId);
            });
          }
        });
      } else if (type === "raster") {
        map.addSource(id, {
          type: type,
          tiles: [
            `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/tilemap/raster/{x}.{y}.{z}.${vrstvyUrl["internal"][type]}.jpg`,
          ],
          tileSize: 256,
          maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
        });
        map.addLayer(
          {
            id: id,
            type: type,
            source: id,
            maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
            minzoom: get(get_store(configStore), "layers.minzoom", 20),
          },
          firstLayerId
        );
      }
    }

    for (const type in vrstvyUrl["external"]) {
      for (const vrst in vrstvyUrl["external"][type]) {
        const id = `externe_vrstvy_${vrstvyUrl["external"][type][vrst].kod}`;

        if (sourceExists(id)) {
          continue;
        }

        const layers = map.getStyle() ? map.getStyle().layers : false;
        const firstLayerId = layers.length ? layers[0].id : null;

        if (
          vrstvyUrl["external"][type][vrst].url.startsWith("http") === false
        ) {
          datalayer(map, vrstvyUrl["external"][type][vrst]);
        } else {
          if (type === "raster") {
            map.addSource(id, {
              type: "raster",
              tiles: [`${vrstvyUrl["external"][type][vrst].url}`],
              tileSize: 256,
              maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
            });
            map.addLayer(
              {
                id: id,
                type: "raster",
                source: id,
                maxzoom: get(get_store(configStore), "layers.maxzoom", 20),
                minzoom: get(get_store(configStore), "layers.minzoom", 20),
              },
              podkladova_interna ||
                vrstvyUrl["external"][type][vrst].input_type === "checkbox"
                ? null
                : firstLayerId
            );
          }
        }
      }
    }
  });

  const dlbclick_func = (e) => {
    hooksStore.doAction("dblclick", e);
  };

  // kontroluje sa v tempe, ci je premenna meranieAktivne
  // podla toho povoluje alebo zakazuje dvojklik
  const unsubscribe = tempStore.subscribe((value) => {
    meranieAktivne = get(value, "meranieAktivne", false);
    if (map) {
      if (!meranieAktivne) {
        map.on("dblclick", dlbclick_func);
      } else {
        map.off("dblclick", dlbclick_func);
      }
    }
  });

  // ziskam si zemenpisnu dlzku, sirku a zoom
  const { lat, lng, zoom } = ziskajUlozenuPoziciuMapy();

  onMount(() => {
    map = new maplibregl.Map({
      container: container,
      center: [lng, lat], //17.27412, 48.22231 [lng, lat]
      zoom: zoom,
      minZoom: 9,
      maxZoom: get(get_store(configStore), "map.maxZoom", 20),
      // maxBounds: obecConfig.map.maxBounds,
      style: {
        version: 8,
        sources: {},
        layers: [],
        glyphs: "assets/fonts/{fontstack}/{range}.pbf",
      },
      preserveDrawingBuffer: true,
      hash: true,
      doubleClickZoom: false,
      transformRequest: (url, resourceType) => {
        if (
          url.includes("zbgisws.skgeodesy.sk") === false &&
          url.includes("fonts.openmaptiles.org") === false
        ) {
          return {
            url: url,
            credentials: "include", // Include cookies for cross-origin requests
          };
        }
      },
    });

    map.on("moveend", (x) => {
      ulozAktualneZobrazenieMapy(map);
    });

    map.on("render", function () {
      // map.resize();
    });

    map.on("load", () => {
      map.resize();
      map.doubleClickZoom.disable();
      hooksStore.doAction("aktualizujVrstvyNaMape");
      map.loadImage(`/assets/img/marker-icon.png`, function (error, image) {
        if (error) throw error;
        map.addImage("marker", image, { pixelRatio: 1, sdf: true }); // 38x55px, shadow adds 5px (for scale eq 1)
      });
      map.loadImage(`/assets/img/light-bulb.png`, function (error, image) {
        if (error) throw error;
        map.addImage("bulb", image, { pixelRatio: 1, sdf: true }); // 38x55px, shadow adds 5px (for scale eq 1)
      });
      map.loadImage(`/assets/img/meteostanica.png`, function (error, image) {
        if (error) throw error;
        map.addImage("meteostanica", image, { pixelRatio: 1, sdf: true }); // 38x55px, shadow adds 5px (for scale eq 1)
      });
      map.loadImage(`/assets/img/video-camera.png`, function (error, image) {
        if (error) throw error;
        map.addImage("video-camera", image, { pixelRatio: 1, sdf: true }); // 38x55px, shadow adds 5px (for scale eq 1)
      });
      hooksStore.doAction("nacitajUlozenyStav");
    });

    map.on("dblclick", dlbclick_func);

    return () => {
      map.remove();
      // link.parentNode.removeChild(link);
    };
  });
</script>

<!-- Map start  -->
<div class="content__map" bind:this={container}>
  {#if map}
    <slot />
    <SideManager />
    <Popup />
    <Controls />
  {/if}
</div>

<!-- Map end  -->
<style>
  .content__map {
    position: relative;
    width: 100%;
    height: 100%;
  }
</style>
